<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :viewBox="`${ size.positionX } ${ size.positionY } ${ size.width } ${ size.height }`"
        :width="`${size.width}px`"
        :height="`${size.height}px`"
    >
        <g :fill="color">
            <slot />
        </g>
    </svg>
</template>

<script>
export default {
    name: "SvgIcon",
    props: {
        color: {
            type: String,
            default: "currentColor"
        },
        size: {
            type: Object,
            required: true
        }
    }
}
</script>
